import { flattenNestedObject } from "../../../../../core/utils/utilFunctions";
import type { TerminalProfileDto } from "../../types/TerminalProfileDto";
import type { TerminalProfileEntity } from "../../types/TerminalProfileEntity";

export const TerminalProfileDtoToEntity = ({
    dynamicProperties,
    terminalConfiguration,
    merchantReferenceNumber1,
    merchantReferenceNumber2,
    tipHandling,
    surchargeAmount,
    taxAmount,
    ...rest
}: Readonly<TerminalProfileDto>): TerminalProfileEntity => {
    const propValues = dynamicProperties?.dynamicPropertyValues?.map((propValue) => {
        const value = propValue.type === "CHECKBOX" ? propValue.value === "true" : propValue.value;

        return {
            id: propValue.id,
            key: propValue.key,
            type: propValue.type,
            label: propValue.label,
            pattern: propValue.pattern ?? "",
            readOnly: propValue.readOnly || false,
            mandatory: propValue.mandatory || false,
            value,
        };
    });

    const flattenedTerminalConfiguration = flattenNestedObject(terminalConfiguration, "terminalConfiguration");

    // Flatten nested DTO fields into dotted keys on the Entity, mirroring AcquirerPhysicalDtoToEntity
    const flattenedMerchantRef1 = flattenNestedObject(merchantReferenceNumber1, "merchantReferenceNumber1");
    const flattenedMerchantRef2 = flattenNestedObject(merchantReferenceNumber2, "merchantReferenceNumber2");
    const flattenedTipHandling = flattenNestedObject(tipHandling, "tipHandling");
    const flattenedSurchargeAmount = flattenNestedObject(surchargeAmount, "surchargeAmount");
    const flattenedTaxAmount = flattenNestedObject(taxAmount, "taxAmount");

    return {
        ...rest,
        ...flattenedTerminalConfiguration,
        ...flattenedMerchantRef1,
        ...flattenedMerchantRef2,
        ...flattenedTipHandling,
        ...flattenedSurchargeAmount,
        ...flattenedTaxAmount,
        dynamicProperties: {
            ...dynamicProperties,
            dynamicPropertyValues: propValues,
        },
    } as TerminalProfileEntity;
};
